"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StackableBorderBox = void 0;

var _styledSystem = require("styled-system");

var _helpers = require("../../helpers");

var _primitives = require("../../platform/primitives");

var _BorderBox = require("../BorderBox");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: ", "px;\n    ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", "px;\n  ", ";\n\n  ", ";\n\n  :not(:first-child) {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  :not(:last-child) {\n    border-bottom: 0;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * A stackable border box is a BorderBox that shares borders with its siblings.
 */
var StackableBorderBox = (0, _primitives.styledWrapper)(_BorderBox.BorderBox)(_templateObject(), (0, _helpers.space)(3), _styledSystem.space, _helpers.media.sm(_templateObject2(), (0, _helpers.space)(2), _styledSystem.space));
exports.StackableBorderBox = StackableBorderBox;
StackableBorderBox.displayName = "StackableBorderBox";
//# sourceMappingURL=StackableBorderBox.js.map